import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, filter, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Distributori } from 'src/app/models/distributori';
import { ImportResult } from 'src/app/models/import-result';
import notify from 'devextreme/ui/notify';
@Injectable({
  providedIn: 'root',
})
export class DistributoriService {
  distributoriUrl = environment.ildatoArticoliDpi + 'api/distributori';
  private http = inject(HttpClient);

  private _listDistributori = new BehaviorSubject<Distributori[] | undefined>(undefined);

  list(): Observable<Distributori[]> {
    return this.http.get<Distributori[]>(this.distributoriUrl);
  }

  listTemp(forceRefresh: boolean = false): Observable<Distributori[]> {
    if (
      this._listDistributori.value == undefined ||
      forceRefresh
    ) {
      this.http.get<Distributori[]>(this.distributoriUrl).subscribe({
        next: (res) => {
          this._listDistributori.next(res);
        },
        error: (err) => {
          if (err?.error?.title) {
            notify(err.error.title, 'error');
          } else {
            notify('Errore recupero lista distributori', 'error');
          }
        },
      });
    }

    return this._listDistributori.asObservable().pipe(filter((r) => r != null));
  }

  get(id: number): Observable<Distributori> {
    return this.http.get<Distributori>(this.distributoriUrl + '/' + id);
  }

  insert(values: Distributori): Observable<Distributori> {
    return this.http.post<Distributori>(this.distributoriUrl, values);
  }

  remove(idDistributore: number): Observable<Distributori> {
    return this.http.delete<Distributori>(
      this.distributoriUrl + '/' + idDistributore,
    );
  }

  update(key: number, values: Distributori): Observable<Distributori> {
    return this.http.put<Distributori>(
      this.distributoriUrl + '/' + key,
      values,
    );
  }

  importDatiDistributore(
    idDistributore: number,
    data: FormData,
  ): Observable<ImportResult> {
    return this.http.post<ImportResult>(
      this.distributoriUrl + '/importaMovimentiDistributore/' + idDistributore,
      data,
    );
  }

  cleanTemp(){
    this._listDistributori.next(undefined);
  }
}
